import { makeAutoObservable } from "mobx";
import { RArray } from "../../collections";
import { OnTimeFulfillmentTime, } from "../FulfillmentTime";
/**
 * A parent container for all information about the restaurant (menu, timezone, etc...)
 */
export class Restaurant {
    constructor(params) {
        this.id = params.id;
        this.menu = params.menu;
        this.packingAlgorithm = params.packingAlgorithm;
        this.timezone = params.timezone;
        this.appOrigin = params.appOrigin;
        this.orderingPolicy = params.orderingPolicy;
        this.orderingAvailability = params.orderingAvailability;
        this.orderingHours = params.orderingHours;
        this.holidays = params.holidays;
        this.minOrderValue = params.minOrderValue;
        this.crossSellingListProvider = params.crossSellingListProvider;
        this.fulfillmentTimes = params.fulfillmentTimes;
        this.fulfillmentMethods = params.fulfillmentMethods;
        this._paymentMethods = params.paymentMethods;
        this._paymentChannels = params.paymentChannels;
        this.tips = params.tips;
        makeAutoObservable(this);
    }
    /**
     * Returns possible fulfillment times at current moment and current moment itself
     */
    currentFulfillmentTimes(now) {
        const times = this.fulfillmentTimes.map((t) => t.type === "ASAP" ? now : t.date);
        return { times, now };
    }
    /**
     * Returns possible fulfillment times at given date.
     * TODO: getting fulfillment times in one way, no matter if its today or not, is a bit weird.
     */
    dateFulfillmentTimes(date) {
        if (date.isToday) {
            return this.fulfillmentTimes.mapOptional((item) => item.type === "OnTime" ? item : null);
        }
        else {
            return this.orderingHours
                .fulfillmentDates(date, this.holidays)
                .map((date) => new OnTimeFulfillmentTime({ date, label: null }));
        }
    }
    get isNoContactDeliveryAvailable() {
        if (this.fulfillmentMethods.size === 1 &&
            this.fulfillmentMethods.includes("NoContactDelivery")) {
            return false;
        }
        else {
            return this.fulfillmentMethods.includes("NoContactDelivery");
        }
    }
    get hasAsapFulfillmentTime() {
        return this.fulfillmentTimes.some((ft) => ft.type === "ASAP");
    }
    get paymentMethods() {
        if (this.appOrigin === "QrWaiter") {
            return this._paymentMethods.filtered((paymentMethod) => paymentMethod !== "Cash" && paymentMethod !== "Card");
        }
        return this._paymentMethods;
    }
    get paymentChannels() {
        return this.paymentMethods.includes("Online")
            ? this._paymentChannels
            : RArray.empty();
    }
    // TODO: move ASAP label translations to the client (currently received from RPC)
    get asapLabel() {
        var _a, _b;
        return ((_b = (_a = this.fulfillmentTimes.findWhere((item) => item.type === "ASAP")) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : null);
    }
}
